import { render, staticRenderFns } from "./quick-view.vue?vue&type=template&id=1453ab89&scoped=true"
import script from "./quick-view.ts?vue&type=script&lang=ts&external"
export * from "./quick-view.ts?vue&type=script&lang=ts&external"
import style0 from "./quick-view.less?vue&type=style&index=0&id=1453ab89&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1453ab89",
  null
  
)

export default component.exports